var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing;
  return {
    tableBottomPadding: spacing.medium,
    colorGreen: '#0b874b'
  };
};
export default generateComponentTheme;